<template>
<!--  <HelloWorld/>-->
  <FixedBandle></FixedBandle>

</template>

<script>
import FixedBandle from './components/FixedBandle.vue';

export default {
    name: 'App',
    components: {
      FixedBandle
  }
}
</script>

<style>
  #c-calendar-bandle {
    position: fixed;
    width: 100%;
    height: auto;
    left: 0;
    bottom: 0;
    z-index: 999;
  }
</style>
